var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flap"},[_c('AppIcon',{staticClass:"flap__icon",attrs:{"size":_vm.flapIconSize,"icon":_vm.icon}}),(_vm.withBadge)?_c('span',{staticClass:"flap__badge"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }